import type { CatalogProduct } from "@/lib/catalog";
import { ProductCard } from "@/components/ProductCard";

type ProductGridProps = {
  title: string;
  subtitle?: string;
  products: CatalogProduct[];
};

export function ProductGrid({ title, subtitle, products }: ProductGridProps) {
  const visible = products.filter(Boolean);
  if (!visible.length) return null;

  return (
    <section className="container py-16 md:py-20" aria-labelledby="products-heading">
      <div className="mb-10 max-w-3xl">
        <h2 id="products-heading" className="font-sans text-3xl font-bold tracking-tight md:text-4xl">
          {title}
        </h2>
        {subtitle ? <p className="mt-3 text-lg text-muted-foreground">{subtitle}</p> : null}
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((product) => (
          <ProductCard key={product.slug} product={product} />
        ))}
      </div>
    </section>
  );
}
